// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checkbox-list {
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  height: 100%;
}

.checkbox-list .checkbox-list-item.nested {
  padding-left: 30px;
}

.checkbox-list .checkbox-list-item {
  padding-top: 8px;
  padding-bottom: 3px;
  margin-bottom: 0;
  border-bottom: solid 1px #dae2e8;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  margin-right: 0px;
  height: 41px;
  position: relative;
  padding-right: 43px;
}

.checkbox-list .checkbox-list-item:hover {
  background: #f5f8fa;
}

.checkbox-list .checkbox label {
  padding-left: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  display: inline;
}

p-inputswitch {
  position: absolute;
  left: 275px;
  margin-top: 2px;
}

.hide {
  display: none;
}

.axisToggle {
  transition: none;
}`, "",{"version":3,"sources":["webpack://./src/app/components/checkbox-list/checkbox-list.component.scss","webpack://./../PSR%20ESP%20WebApp%20Build/src/app/components/checkbox-list/checkbox-list.component.scss","webpack://./src/assets/_wfm_variables.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;ACAF;;ADEA;EACE,kBAAA;ACCF;;ADCA;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ACEF;;ADCA;EACE,mBEMe;ADJjB;;ADCA;EACE,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,eAAA;ACEF;;ADAA;EACE,kBAAA;EACA,WAAA;EACA,eAAA;ACGF;;ADDA;EACE,aAAA;ACIF;;ADFA;EACE,gBAAA;ACKF","sourcesContent":["@import \"../../../assets/wfm_variables\";\n.checkbox-list{\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: white;\n  height: 100%;\n}\n.checkbox-list .checkbox-list-item.nested{\n  padding-left:30px;\n}\n.checkbox-list .checkbox-list-item{\n  padding-top: 8px;\n  padding-bottom: 3px;\n  margin-bottom: 0;\n  border-bottom: solid 1px $border-color;\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  margin-right: 0px;\n  height:41px;\n  position: relative;\n  padding-right: 43px;\n}\n\n.checkbox-list .checkbox-list-item:hover{\n  background: $row-hover-color;\n}\n\n.checkbox-list .checkbox label{\n  padding-left:10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  display: inline;\n}\np-inputswitch{\n  position: absolute;\n  left: 275px;\n  margin-top: 2px;\n}\n.hide{\n  display: none;\n}\n.axisToggle{\n  transition: none;\n}\n",".checkbox-list {\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: white;\n  height: 100%;\n}\n\n.checkbox-list .checkbox-list-item.nested {\n  padding-left: 30px;\n}\n\n.checkbox-list .checkbox-list-item {\n  padding-top: 8px;\n  padding-bottom: 3px;\n  margin-bottom: 0;\n  border-bottom: solid 1px #dae2e8;\n  white-space: nowrap;\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  margin-right: 0px;\n  height: 41px;\n  position: relative;\n  padding-right: 43px;\n}\n\n.checkbox-list .checkbox-list-item:hover {\n  background: #f5f8fa;\n}\n\n.checkbox-list .checkbox label {\n  padding-left: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  display: inline;\n}\n\np-inputswitch {\n  position: absolute;\n  left: 275px;\n  margin-top: 2px;\n}\n\n.hide {\n  display: none;\n}\n\n.axisToggle {\n  transition: none;\n}","$font-size-base: 1.4rem;\n$font-family-base: \"Open Sans Regular\";\n$wfm-border-radius: 4px;\n$wfm-active-link-bg: #F2F5F7;\n\n$card-border-radius: $wfm-border-radius;\n$input-border-radius: $wfm-border-radius;\n$input-border-radius-lg: $wfm-border-radius;\n$input-border-radius-sm: $wfm-border-radius;\n$form-group-margin-bottom: 2rem;\n$input-focus-border-color: #007cbe;\n$btn-border-radius: $wfm-border-radius;\n$btn-border-radius-lg: $wfm-border-radius;\n$btn-border-radius-sm: $wfm-border-radius;\n$input-btn-padding-y: 1rem;\n$input-height: 48px;\n$bg-color: #eaf1f7;\n$black: #222f37;\n$white: #ffffff;\n$red: #d82132;\n$green: #00a65a;\n$grey: #8c95a5;\n$blue: #007cbe;\n$header-text-color: #404040;\n$table-header-text-color: #8c95a5;\n$border-color: #dae2e8;\n$dark-border-color: #c1bebe;\n$font-generic: 14px \"opensans-regular\";\n$header-height: 60px;\n$btn-box-shadow-color: #105286;\n$column-header-cell-color: #8c95a5;\n$row-hover-color:#f5f8fa\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
